export default __webpack_public_path__ + "static/media/DeerEmpire - TrainStationBlues.579f1acd.mp3";